import { MFA_FACTOR_IDS } from '../../features/authentication/constants';

const MFA_SETUP_PATHS = {
  [MFA_FACTOR_IDS.TOTP]: `/mfa-setup/${MFA_FACTOR_IDS.TOTP}`,
  [MFA_FACTOR_IDS.PHONE]: `/mfa-setup/${MFA_FACTOR_IDS.PHONE}`,
};

const normalizePathname = (pathname?: unknown) => {
  if (typeof pathname !== 'string') {
    return '';
  }

  if (pathname.length <= 1) {
    return pathname;
  }

  return pathname.replace(/\/+$/, '');
};

export const getRequestedMFAFactorId = (pathname?: unknown) => {
  const normalizedPathname = normalizePathname(pathname);

  if (normalizedPathname === MFA_SETUP_PATHS[MFA_FACTOR_IDS.TOTP]) {
    return MFA_FACTOR_IDS.TOTP;
  }

  if (normalizedPathname === MFA_SETUP_PATHS[MFA_FACTOR_IDS.PHONE]) {
    return MFA_FACTOR_IDS.PHONE;
  }

  return null;
};
